import React, { useEffect } from "react"
import "./Staff.css"


const Staff = () => {

  useEffect(() => {
    document.title = "Library Staff - Central Library - Rayalaseema University"
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
     

      {/* ================= HEADER ================= */}
      <section className="library-staff-header">
        <div className="library-staff-container">
          <h1>Central Library – Staff</h1>
          <p>
            The Central Library is supported by qualified and experienced
            professionals who assist students, researchers, and faculty
            in accessing academic resources and services.
          </p>
        </div>
      </section>

      {/* ================= STAFF TABLE ================= */}
      <section className="library-staff-table-section">
        <div className="library-staff-container">

          <table className="library-staff-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Email</th>
                <th>Mobile</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>1</td>
                <td><strong>Mr. S. Nagabhushanam</strong></td>
                <td>Library Assistant Grade-I</td>
                <td>
                  <a href="mailto:rayalaseemauniversitylibrary@gmail.com">
                    rayalaseemauniversitylibrary@gmail.com
                  </a>
                </td>
                <td>9182897194</td>
              </tr>

              <tr>
                <td>2</td>
                <td>D. Venkatesulu</td>
                <td>Library Assistant Grade-II (MTS)</td>
                <td>—</td>
                <td>—</td>
              </tr>

              <tr>
                <td>3</td>
                <td>B. Marenna</td>
                <td>Library Assistant Grade-II (MTS)</td>
                <td>—</td>
                <td>—</td>
              </tr>

              <tr>
                <td>4</td>
                <td>M. Bhagyalakshmi</td>
                <td>Office Assistant (MTS)</td>
                <td>—</td>
                <td>—</td>
              </tr>

              <tr>
                <td>5</td>
                <td>V. Kiranmai</td>
                <td>Office Assistant (Contract)</td>
                <td>—</td>
                <td>—</td>
              </tr>
            </tbody>
          </table>

        </div>
      </section>

    
    </>
  )
}

export default Staff
